/* "Bought together": loads complementary products, sums the selected ones and adds them with a single /cart/add.js call. */
(() => {
  if (customElements.get('kora-bundle')) return;
  const K = (window.Kora = window.Kora || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  class KoraBundle extends HTMLElement {
    connectedCallback() {
      this.inner = $('[data-bundle-inner]', this);
      if (!this.inner || !this.dataset.url) return;
      this.list = $('[data-bundle-list]', this);
      this.form = $('[data-bundle-form]', this);
      const d = Number(this.dataset.decimals) || 0;
      try {
        this.fmt = new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency, minimumFractionDigits: d, maximumFractionDigits: d });
      } catch (e) { this.fmt = { format: (n) => n.toFixed(d) }; }
      this.form.addEventListener('change', (e) => {
        const item = e.target.closest('[data-bundle-item]');
        if (item && e.target.matches('[data-bundle-variant]')) this.showPrice(item);
        this.update();
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
      this.onVariant = (e) => this.syncCurrent(e.detail);
      document.addEventListener('product:variant-change', this.onVariant);
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { this.io.disconnect(); this.load(); }
      }, { rootMargin: '300px 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('product:variant-change', this.onVariant);
    }
    async load() {
      try {
        const res = await fetch(this.dataset.url);
        if (!res.ok) return;
        const doc = K.parseHTML ? K.parseHTML(await res.text()) : new DOMParser().parseFromString(await res.text(), 'text/html');
        const items = $$('[data-bundle-response] > [data-bundle-item]', doc);
        if (!items.length) return;
        items.forEach((li) => this.list.appendChild(document.adoptNode(li)));
        this.inner.hidden = false;
        this.update();
      } catch (e) { /* stay hidden */ }
    }
    variantOf(item) {
      const el = $('[data-bundle-variant]', item);
      return el && (el.tagName === 'SELECT' ? el.selectedOptions[0] : el);
    }
    showPrice(item) {
      const v = this.variantOf(item);
      const out = $('[data-bundle-price]', item);
      if (v && out) out.textContent = v.dataset.fmt;
    }
    syncCurrent(detail) {
      if (!detail || String(detail.productId) !== this.dataset.productId) return;
      const item = $(`[data-bundle-item][data-product-id="${this.dataset.productId}"]`, this);
      const sel = item && $('select[data-bundle-variant]', item);
      if (!sel) return;
      const opt = $$('option', sel).find((o) => o.value === String(detail.variantId));
      if (opt && !opt.disabled) { sel.value = opt.value; this.showPrice(item); this.update(); }
    }
    selected() {
      return $$('[data-bundle-item]', this).filter((i) => $('[data-bundle-check]', i).checked).map((i) => this.variantOf(i)).filter(Boolean);
    }
    update() {
      const chosen = this.selected();
      const cents = chosen.reduce((sum, v) => sum + Number(v.dataset.price || 0), 0);
      $('[data-bundle-total]', this).textContent = this.fmt.format(cents / 100);
      $('[data-bundle-count]', this).textContent = chosen.length ? `(${chosen.length})` : '';
      $('[data-bundle-submit]', this).disabled = !chosen.length;
    }
    async submit() {
      const chosen = this.selected();
      if (!chosen.length) return;
      const btn = $('[data-bundle-submit]', this);
      const err = $('[data-bundle-error]', this);
      err.hidden = true;
      btn.classList.add('is-loading');
      try {
        const res = await fetch(`${K.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: chosen.map((v) => ({ id: Number(v.value || v.getAttribute('value')), quantity: 1 })), sections: 'cart-drawer', sections_url: location.pathname })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || K.strings.error);
        const count = K.cart.countFromSections(data.sections);
        if (count !== null) K.cart.setCount(count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { sections: data.sections, itemCount: count, source: 'add' } }));
        if (K.cartType === 'page') { location.href = K.routes.cart; return; }
        document.dispatchEvent(new CustomEvent('cart-drawer:open', { detail: { trigger: btn } }));
        K.announce(K.strings.added);
      } catch (e) {
        err.textContent = e.message;
        err.hidden = false;
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }
  customElements.define('kora-bundle', KoraBundle);
})();
